import {routes, request} from "./"

export function fetchData (commit) {
    return request(commit, routes.fetchData, null, 'get', true, false)
}

export function fetchPriorityData (commit) {
    return request(commit, routes.fetchPriorityData)
}



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/api/main.js
// module id = 606
// module chunks = 0